// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"8c0e9ec8","187":"90ff765f","234":"cfd109e8","589":"d3ad79da","666":"ad8076f4","680":"f3311c6d","727":"08e3c02d","794":"ecf1399a","849":"0db60306"}[chunkId] + ".chunk.js";
};